/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AccordionContainerEnhanced } from '@marriott/mi-common-static-components';
import { StyledDestinationsList } from './DestinationsList.styles';
import { generateCardData, getTotalPropertyCount } from './utils/destinationsListUtils';
import { shouldUseMockData } from '../../utils/CommonUtils';

export const DestinationsListWrapper: FC<any> = props => {
  const { model, isAuthorMode, mbeData } = props;
  const [mockdataInAuthorMode, setMockDataInAuthorMode] = useState<any>({});

  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockModule = await import('./__mock__/DestinationsList.mocks');
      return mockModule.destinationsListAPIdata;
    }
    return {};
  };

  useEffect(() => {
    const fetchMockData = async () => {
      const mockData = await GetMockData(isAuthorMode);
      setMockDataInAuthorMode(mockData);
    };
    fetchMockData();
  }, [isAuthorMode]);

  const destinationsListData = (isAuthorMode ? mockdataInAuthorMode : mbeData)?.responseObject?.offers?.mbeOfferById
    ?.offers?.destination;

  const orderedRegions: any = [];
  model?.regionImagesList?.forEach((item: any) => {
    const regionCode = item?.regionCode;
    const regions = Array.isArray(destinationsListData?.regions) ? destinationsListData.regions : [];
    orderedRegions.push(...regions.filter((item: any) => item?.code === regionCode));
  });

  const headerList = orderedRegions?.map((region: { code: any; name: any }, index: any) => {
    const regionPropertyCount = getTotalPropertyCount(region);
    const matchedMedia = model?.regionImagesList?.find(
      (media: { regionCode: any }) => media.regionCode === region.code
    );

    const header = `${matchedMedia?.header ?? region?.name} (${regionPropertyCount})`;

    return {
      nodeName: `card-${index}`,
      drawerHeaderTag: 'h2',
      assetVariation: 'image',
      header: header,
      dynamicMedia: matchedMedia ? matchedMedia?.dynamicMedia : '',
    };
  });
  const cards = orderedRegions?.map((region: any, index: number) => generateCardData(region, index));
  const cardsObject = Object.assign({}, ...(cards ?? []));
  const itemsOrder = ['headerListItems', ...(cards ?? []).map((_: any, index: number) => `card-${index}`)];

  const modifiedModel = {
    ...model,
    rootHeaderTag: 'h2',
    rootHeaderFontStyle: 't-body-m',
    headerAlignment: 'left',
    activateDrawerBehavior: false,
    merchandisingCategory: 'nonCobrand',
    impressionCount: 'false',
    rootHeaderText: model?.title ?? `<p>${destinationsListData?.title}</p>`,
    headerListItems: headerList || [],
    isAuthor: 'false',
    isAuthorMode: false,
    wcmMode: 'disabled',
    ':items': {
      ...cardsObject,
      headerListItems: {
        ':type': 'nt:unstructured',
      },
    },
    ':itemsOrder': itemsOrder,
  };
  return (
    <StyledDestinationsList>
      <div className="destinations-list">
        <AccordionContainerEnhanced model={modifiedModel} allowedComponents={props?.allowedComponents} />
      </div>
    </StyledDestinationsList>
  );
};

const DestinationsListConfig = {
  emptyLabel: 'DestinationsList',
  isEmpty: false,
  resourceType: 'mi-aem-offers-spa/components/destinationsList',
};

export const DestinationsList = (props: any) => (
  <div data-testid="offers-DestinationsList" data-component-name="o-offers-DestinationsList">
    <EditableComponent config={DestinationsListConfig} {...props}>
      <DestinationsListWrapper {...props} />
    </EditableComponent>
  </div>
);
